import {
  Box,
  BoxProps,
  CircularProgress,
  CircularProgressProps,
} from "@mui/material";
import { NAVBAR_HEIGHT } from "../Navbar/NavDesktop";

type SpinnerProps = BoxProps & {
  height?: number | string; // Container height; defaults to viewport minus navbar
  size?: number; // CircularProgress size
  label?: string; // Screen-reader label
  fullscreen?: boolean; // If false, doesn't force a tall container
  progressColor?: CircularProgressProps["color"];
};

export const Spinner: React.FC<SpinnerProps> = ({
  height,
  size = 80,
  label = "Loading…",
  fullscreen = true,
  progressColor = "primary",
  sx,
  ...rest
}) => (
  <Box
    aria-busy="true"
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height:
        height ?? (fullscreen ? `calc(100vh - ${NAVBAR_HEIGHT})` : "auto"),
      ...(fullscreen && { minHeight: 200 }),
      ...sx,
    }}
    {...rest}
  >
    <CircularProgress size={size} aria-label={label} color={progressColor} />
  </Box>
);
